export class ExportUnsupportedError extends Error {
  constructor(feature = 'OffscreenCanvas') {
    super(`Export is not supported in this browser because ${feature} is unavailable.`)
    this.name = 'ExportUnsupportedError'
  }
}

export class ExportWorkerError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ExportWorkerError'
  }
}

export class ExportTooLargeError extends Error {
  constructor(
    readonly neededMp: number,
    readonly limitMp: number,
  ) {
    super(`Export needs a ${neededMp.toFixed(1)} MP canvas, but this device supports up to ${limitMp.toFixed(1)} MP.`)
    this.name = 'ExportTooLargeError'
  }
}

export class EncodeFailedError extends Error {
  constructor() {
    super('The browser returned an empty image while encoding the export.')
    this.name = 'EncodeFailedError'
  }
}
